// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","470":"vendor.chart.js"}[chunkId] + "." + {"96":"37b2e4e8","470":"23d5b0e4"}[chunkId] + ".js";
};